import { render } from "./list-client-subtype.vue?vue&type=template&id=21e6e405&lang=html"
import script from "./list-client-subtype.vue?vue&type=script&lang=js"
export * from "./list-client-subtype.vue?vue&type=script&lang=js"

import "./list-client-subtype.vue?vue&type=style&index=0&id=21e6e405&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__